import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import formatCurrency from "functions/formatCurrency";
import APILink from "components/ui/APILink";
import { SmallModernBlueButtonLink } from "components/ui/ButtonLink";

export const columnShape = PropTypes.shape({
  amount: PropTypes.number,
  value: PropTypes.string,
  link: PropTypes.object,
});

export function Columns({ left, right, showDecimals }) {
  return (
    <FlexColumns>
      <Column column={left} showDecimals={showDecimals} />
      <RightColumn column={right} showDecimals={showDecimals} />
    </FlexColumns>
  );
}
Columns.displayName = "Columns";
Columns.propTypes = {
  left: columnShape,
  right: columnShape,
  showDecimals: PropTypes.bool,
};

function Column({ column, showDecimals, align = "left" }) {
  const { amount, value } = column;
  return (
    <div style={{ textAlign: align }}>
      <div>{formatCurrency(amount, { showDecimals })}</div>
      <ValueLabel $greenText={["Disbursed", "Earned"].includes(value)}>
        {value}
      </ValueLabel>
    </div>
  );
}
Column.displayName = "Column";
Column.propTypes = {
  column: columnShape,
  showDecimals: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right"]),
};

function RightColumn({ column, showDecimals }) {
  const { link } = column;

  if (link && link.url) {
    return (
      <div style={{ textAlign: `right` }}>
        <APILink link={link} as={SmallModernBlueButtonLink} />
      </div>
    );
  }

  return <Column column={column} showDecimals={showDecimals} align="right" />;
}
RightColumn.displayName = "RightColumn";
RightColumn.propTypes = {
  column: columnShape,
  showDecimals: PropTypes.bool,
};

const FlexColumns = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ValueLabel = styled.div`
  text-transform: uppercase;
  font-size: 12px;
  color: ${({ $greenText }) =>
    $greenText ? `var(--jewel)` : `var(--dove-gray)`};
`;
